import React, { useEffect, useState } from 'react'
import { baseURLProd } from '../../api';
import LoginHook from '../Login/LoginHook';

const MyprofileHook = () => {
    const userId = localStorage.getItem("userId");
    const [userDetail, setUserDetail] = useState("");

    const handleProfileDetail = async () => {
        const formData = new FormData();
        formData.append("user_id", userId);
        try {
            const response = await fetch(`${baseURLProd}get-user`, {
                method: "POST",
                body: formData,
            });

            const data = await response.json();
            if (data) {
                setUserDetail(data)
            } else {
                alert("Login failed: " + data.message);
            }
        } catch (error) {
            console.error("Error logging in:", error);
            alert("An error occurred. Please try again later.");
        }
    };

    useEffect(() => {
        handleProfileDetail()
    }, [])

    return {
        userId, setUserDetail, userDetail
    }
}

export default MyprofileHook
